import gql from 'graphql-tag'

export const TASK_DELETE_MUTATION = gql`
    mutation taskDelete(
        $id: ID!
    ) {
        taskDelete(
            id: $id
        ) {
            status
        }
    }
`
